import React from 'react';
import { useTranslation } from 'react-i18next';
import { VALIDATION_RULES } from '../constants';
import '../styles/ContactForm.css';

interface FormFieldProps {
  id: string;
  name: string;
  label: string;
  type?: 'text' | 'email' | 'tel';
  value: string;
  error?: string;
  required?: boolean;
  placeholder?: string;
  labelPosition?: 'above' | 'below';
  maxLength?: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormField: React.FC<FormFieldProps> = ({
  id,
  name,
  label,
  type = 'text',
  value,
  error,
  required = false,
  placeholder,
  labelPosition = 'above',
  maxLength = VALIDATION_RULES.textField.maxLength,
  onChange
}) => {
  const { t } = useTranslation();
  const requiredLabel = t('accessibility.required');

  return (
    <div className={`form-group ${labelPosition === 'below' ? 'label-below' : ''}`}>
      {labelPosition === 'above' && (
        <label htmlFor={id}>
          {label} {required && <span aria-label={requiredLabel}>*</span>}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        maxLength={maxLength}
        aria-describedby={error ? `${id}-error` : undefined}
        aria-invalid={!!error}
      />
      {labelPosition === 'below' && (
        <label htmlFor={id}>
          {label} {required && <span aria-label={requiredLabel}>*</span>}
        </label>
      )}
      {error && (
        <div id={`${id}-error`} className="form-error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default FormField;

